import { useQuery } from "@tanstack/react-query";

import { integrationsApi } from "../api/integrations.api";
import type { IntegrationQueryParams } from "../types";

// Query key factory
export const integrationsKeys = {
  all: ['integrations'] as const,
  list: (params: IntegrationQueryParams) => [...integrationsKeys.all, 'list', params] as const,
} as const;

/**
 * Hook for fetching integrations
 * Returns React Query result directly - use isPending, isError, data, error properties
 */
export function useIntegrations(params: IntegrationQueryParams = {}) {
  return useQuery({
    queryKey: integrationsKeys.list(params),
    queryFn: () => integrationsApi.fetchIntegrations(params),
    staleTime: 20 * 60 * 1000, // 20 minutes
  });
}
